import startOfDay from 'date-fns/startOfDay'

export interface IAvailableDays {
  days: Map<string, number>
}

export interface IAvailableDaysFactory extends  IAvailableDays {
}

export interface IDay {

}

export class AvailableDays {
  days: Map<string, number>

  constructor(availableDaysData: IAvailableDays) {
    this.days = availableDaysData.days
  }

  getOrdersCountByDate(date: Date): number {
    const foundDay = this.days.get(startOfDay(date).toString())
    if (!foundDay) {
      return 0
    }

    return foundDay
  }

  getOrdersCountForDaysAfterTomorrow(): number {
    // Always recalculate to handle day transitions dynamically
    // Don't use caching because dates change at midnight
    
    const today = startOfDay(new Date())
    const tomorrow = startOfDay(new Date(today))
    tomorrow.setDate(tomorrow.getDate() + 1)

    const daysAfterTomorrow = new Map(this.days)
    
    // Debug logging to understand what's happening
    console.log('[AvailableDays] Calculating days after tomorrow:')
    console.log('  Today:', today.toString())
    console.log('  Tomorrow:', tomorrow.toString())
    console.log('  All days in map:', Array.from(this.days.keys()))
    
    daysAfterTomorrow.delete(today.toString())
    daysAfterTomorrow.delete(tomorrow.toString())

    console.log('  Days after tomorrow:', Array.from(daysAfterTomorrow.keys()))

    let count = 0
    daysAfterTomorrow.forEach((ordersCount, date) => {
      console.log(`  Date: ${date}, Orders: ${ordersCount}`)
      count += ordersCount
    })

    console.log('  Total count for days after tomorrow:', count)
    return count
  }

  hasOrders(date: Date): boolean {
    return Boolean(this.getOrdersCountByDate(date))
  }
}

export const createAvailableDays = (availableDaysData: IAvailableDaysFactory): AvailableDays => {

  return new AvailableDays({
    ...availableDaysData,
  })
}
